import {
  BurgerIcon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@cdl/heartbeat-react';
import { Link } from 'react-router-dom';

export const BurgerNav = () => {
  return (
    <Menu>
      <MenuButton
        as={IconButton}
        aria-label='Options'
        icon={<BurgerIcon />}
        variant='outline'
        p='s'
      />
      <MenuList>
        <MenuItem>
          <Link to={'/admin/dashboard'}>Dashboard</Link>
        </MenuItem>
        <MenuItem>
          <Link to={'/'}>Annotation</Link>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
